module.exports = __webpack_public_path__ + "img/christian-viqueira.bd217ec2.jpg";